import * as React from 'react'
import { graphql } from 'gatsby'
import RecommendedProductsSlider from '../sliders/RecommendedProductsSlider'
import PropTypes from 'prop-types'

export const ProductGrid = ({ section }) => {
  return (
    <RecommendedProductsSlider
      heading={section.heading}
      products={section.products}
      className="relative max-w-[1366px] w-full mx-auto py-10"
    />
  )
}

ProductGrid.propTypes = {
  section: PropTypes.shape({
    heading: PropTypes.string,
    products: PropTypes.arrayOf(PropTypes.object).isRequired,
  }),
}

export const query = graphql`
  fragment ProductGridSection on STRAPI__COMPONENT_SECTION_PRODUCT_GRID {
    id
    strapi_component
    heading
    products {
      ...ProductCard
    }
  }
`

export default ProductGrid
